import React from "react";

export default function LoadingElement() {
  return (
    <div
      style={{
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      Loading...
    </div>
  );
}
